import React, { useImperativeHandle, forwardRef, useState } from 'react';

import { Box } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import moment from 'moment';
import { useSnackbar } from 'notistack';

import { montarItensCartaz } from '../../../utils';
import Relatorio from './relatorio';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: 'white',
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6" style={{ fontWeight: 'bold' }}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogoTrocoInicial = forwardRef(({ handleClose = () => {} }, ref) => {
  const [open, setOpen] = useState(false);
  const [dados, setDados] = useState(null);
  const { enqueueSnackbar } = useSnackbar();

  const handleCloseLocal = () => {
    setOpen(false);
    setDados(null);
    handleClose();
  };

  async function getDados(itens, header) {
    try {
      setDados({
        itens: montarItensCartaz(itens),
        titulo: `CARUARU FRIOS - CARTAZES - ${moment().format('DD/MM/YYYY')}`,
        header,
      });
    } catch (e) {
      handleCloseLocal();
      enqueueSnackbar(e ? e.toString() : 'ERROR', {
        variant: 'error',
      });
    }
  }

  useImperativeHandle(ref, () => ({
    handleOpen(itens, header = 'OFERTA') {
      setOpen(true);

      getDados(itens, header);
    },
  }));

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleCloseLocal}
        aria-labelledby="form-dialog-title"
        disableBackdropClick
        disableEscapeKeyDown
        scroll="paper"
        fullScreen
      >
        <DialogTitle
          id="form-dialog-title"
          onClose={handleCloseLocal}
          style={{ backgroundColor: '#009FD4', color: 'white' }}
        >
          Cartazes dos Preços dos Produtos
        </DialogTitle>
        <DialogContent dividers style={{ padding: 0, height: '100%' }}>
          <div style={{ height: '100%' }}>
            <Box
              display={{ xs: 'block', sm: 'flex' }}
              flexDirection="column"
              marginBottom="0px"
              height="100%"
            >
              <Relatorio open={open} dados={dados} />
            </Box>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
});

export default DialogoTrocoInicial;
